import { render, staticRenderFns } from "./TaskVolunteers.vue?vue&type=template&id=abe6d1a4&"
import script from "./TaskVolunteers.vue?vue&type=script&lang=js&"
export * from "./TaskVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports